import type { FaireProductEntity } from "../../entity_types/product";

export const p_236jcn5z: FaireProductEntity = {
  token: "p_236jcn5z",
  type: "product",
  name: "Happy New Home Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4c5e70498b792e969c1f315451dbb80efc28a65ccbbc45a4da1085a1bbc3254f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3fa738fd59fe8639e178e6cc0cff36f2a05b50719be29d140047059af40c0906/1528389118.png",
    "https://cdn.faire.com/fastly/1d3529a117e15e8cc27f2a99c887cbbf9a49be86cafd60bf45ea8164faf18bad.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:11.886Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
